import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";

import history from '../../history';
import firebase from '../Firebase.js';
export class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: "Active_Forms",
            email: "",
            password: "",
            errorMessage: "",
            logging_in: false,
            mfaResolver: null,
            sending_code: false,
            verificationId: "",
            showMfaInput: false,
            verificationCode: "",
            recaptchaWidgetId: null,
            currentRecaptchaVerifier: null,
            emailVerificationSent: false,
            awaitingEmailVerification: false,
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.email && this.state.password) {
            this.setState({ logging_in: true });
            firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
                .then(async (userCred) => {
                    const user = userCred.user;
                    if (!user.emailVerified) {
                        await user.sendEmailVerification();
                        this.setState({ emailVerificationSent: true, logging_in: false, awaitingEmailVerification: true });
                        return;
                    }
                    history.push("/admin");
                })
                .catch(async (error) => {
                    if (error.code === 'auth/multi-factor-auth-required') {
                        const resolver = error.resolver;
                        this.setState({ mfaResolver: resolver, logging_in: false, errorMessage: "" });
                        try {
                            // Create a fresh invisible reCAPTCHA instance for each MFA attempt
                            const recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', { size: 'invisible' });
                            await recaptchaVerifier.render();
                            const phoneInfoOptions = { multiFactorHint: resolver.hints[0], session: resolver.session };
                            const phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
                            const verificationId = await phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
                            this.setState({ verificationId, showMfaInput: true, logging_in: false, currentRecaptchaVerifier: recaptchaVerifier });
                        } catch (mfaErr) {
                            this.setState({ errorMessage: mfaErr.message, password: "" });
                        }
                    } else {
                        var errorMessage = error.message;
                        this.setState({ errorMessage: errorMessage, logging_in: false, password: "" });
                    }
                });
        }
    };

    handleVerifyCode = async (e) => {
        e.preventDefault();
        const { verificationId, verificationCode, mfaResolver } = this.state;
        if (!verificationCode) { this.setState({ errorMessage: "Please enter the code." }); return; }
        try {
            const cred = firebase.auth.PhoneAuthProvider.credential(verificationId, verificationCode);
            const assertion = firebase.auth.PhoneMultiFactorGenerator.assertion(cred);
            await mfaResolver.resolveSignIn(assertion);
            history.push('/admin');
        } catch (err) {
            this.setState({ errorMessage: err.message || 'Invalid code' });
        }
    };

    renderHelmet = () => {
        return (
            <Helmet defer={false}>
                {/*
                  Toggle the modern-page body styles via <html className>.
                  See client/src/index.css ".lg-modern-page" rules - they
                  override the legacy /css/loader.css (which forces
                  html/body to 100px), hide the full-screen .full-loader
                  overlay, and set the modern background + font. Using
                  <html> attributes (instead of an inline <style> tag)
                  ensures react-helmet@6.1 correctly REMOVES them on
                  unmount so they don't leak into /admin pages (which
                  would otherwise lose Poppins font + Metronic's flex
                  layout).
                */}
                <html className="lg-modern-page" />
                <meta charSet="utf-8" />
                <title>Admin Login | LoanGateway</title>
                <meta name="description" content="Sign in to the LoanGateway admin portal" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, shrink-to-fit=no"
                />
                <link rel="shortcut icon" href="assets/media/logos/favicon.ico" />
            </Helmet>
        );
    };

    renderEmailVerificationBanner = () => {
        if (!this.state.awaitingEmailVerification) {
            return null;
        }
        return (
            <div
                className="mb-6 rounded-xl border p-4 text-sm"
                style={{ backgroundColor: '#EFF6FF', borderColor: '#BFDBFE', color: '#1E40AF' }}
            >
                <p className="font-semibold mb-1">Verify your email</p>
                <p className="leading-relaxed">
                    A verification link has been sent to{' '}
                    <span className="font-semibold">{this.state.email}</span>. Please verify
                    your email, then click the button below.
                </p>
            </div>
        );
    };

    renderErrorMessage = () => {
        if (!this.state.errorMessage) {
            return null;
        }
        return (
            <p className="mt-3 text-sm" style={{ color: '#DC2626' }}>
                {this.state.errorMessage}
            </p>
        );
    };

    renderSignInForm = () => {
        return (
            <>
                <div className="mb-8">
                    <h1 className="text-2xl sm:text-3xl font-bold text-[#1F2937]">
                        Admin sign in
                    </h1>
                    <p className="mt-2 text-sm sm:text-base text-[#6B7280] leading-relaxed">
                        Welcome back. Enter your details to access the LoanGateway
                        admin portal.
                    </p>
                </div>

                <div className="mb-5">
                    <label
                        htmlFor="admin-login-email"
                        className="block text-sm font-medium text-[#1F2937] mb-2"
                    >
                        Email <span style={{ color: '#DC2626' }}>*</span>
                    </label>
                    <input
                        id="admin-login-email"
                        type="text"
                        name="username"
                        autoComplete="on"
                        required
                        value={this.state.email}
                        onChange={(e) => { this.setState({ email: e.target.value }); }}
                        placeholder="you@example.com"
                        className="w-full rounded-xl border-2 border-[#E5E7EB] bg-white px-4 py-3 text-base text-[#1F2937] placeholder-[#9CA0AE] focus:outline-none focus:border-[#7C5CFC] transition-colors"
                    />
                </div>

                <div className="mb-6">
                    <div className="flex items-center justify-between mb-2">
                        <label
                            htmlFor="admin-login-password"
                            className="block text-sm font-medium text-[#1F2937]"
                        >
                            Password <span style={{ color: '#DC2626' }}>*</span>
                        </label>
                        <a
                            href="javascript:;"
                            id="kt_login_forgot"
                            className="text-sm font-semibold"
                            style={{ color: '#5B3FE0' }}
                        >
                            Forgot password?
                        </a>
                    </div>
                    <input
                        id="admin-login-password"
                        type="password"
                        name="password"
                        autoComplete="on"
                        required
                        value={this.state.password}
                        onChange={(e) => { this.setState({ password: e.target.value }); }}
                        placeholder="••••••••"
                        className="w-full rounded-xl border-2 border-[#E5E7EB] bg-white px-4 py-3 text-base text-[#1F2937] placeholder-[#9CA0AE] focus:outline-none focus:border-[#7C5CFC] transition-colors"
                    />
                </div>

                <button
                    id="kt_login_signin_submit"
                    type="submit"
                    disabled={this.state.logging_in}
                    className="w-full rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    style={{ backgroundColor: '#7C5CFC' }}
                >
                    {this.state.logging_in ? (
                        <>
                            <span
                                className="inline-block h-4 w-4 rounded-full border-2 border-white border-t-transparent animate-spin"
                            />
                            Signing in…
                        </>
                    ) : (
                        <>Sign in →</>
                    )}
                </button>
            </>
        );
    };

    renderMfaForm = () => {
        return (
            <>
                <div className="mb-8">
                    <span
                        className="inline-flex items-center justify-center h-12 w-12 rounded-2xl mb-5"
                        style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                    >
                        <svg className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                            <path
                                fillRule="evenodd"
                                d="M10 1a4 4 0 014 4v3h1a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h1V5a4 4 0 014-4zm2 7V5a2 2 0 10-4 0v3h4z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </span>
                    <h1 className="text-2xl sm:text-3xl font-bold text-[#1F2937]">
                        Two-factor verification
                    </h1>
                    <p className="mt-2 text-sm sm:text-base text-[#6B7280] leading-relaxed">
                        Enter the 6-digit verification code sent to your registered
                        phone number to complete sign in.
                    </p>
                </div>

                <div className="mb-6">
                    <label
                        htmlFor="admin-login-code"
                        className="block text-sm font-medium text-[#1F2937] mb-2"
                    >
                        Verification code <span style={{ color: '#DC2626' }}>*</span>
                    </label>
                    <input
                        id="admin-login-code"
                        type="text"
                        name="code"
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        value={this.state.verificationCode}
                        onChange={(e) => { this.setState({ verificationCode: e.target.value }); }}
                        placeholder="123 456"
                        className="w-full rounded-xl border-2 border-[#E5E7EB] bg-white px-4 py-3 text-base text-[#1F2937] placeholder-[#9CA0AE] tracking-widest focus:outline-none focus:border-[#7C5CFC] transition-colors"
                    />
                </div>

                <button
                    onClick={this.handleVerifyCode}
                    className="w-full rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95"
                    style={{ backgroundColor: '#7C5CFC' }}
                >
                    Verify &amp; sign in →
                </button>
            </>
        );
    };

    renderAwaitingVerificationCta = () => {
        if (!this.state.awaitingEmailVerification) {
            return null;
        }
        return (
            <div className="mt-6">
                <button
                    onClick={() => window.location.reload()}
                    className="w-full rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95"
                    style={{ backgroundColor: '#1A1D2A' }}
                >
                    I've verified my email
                </button>
            </div>
        );
    };

    render() {
        return (
            <div
                className="min-h-screen w-full flex flex-col lg:flex-row"
                style={{ backgroundColor: '#F5F6FA' }}
            >
                {this.renderHelmet()}

                {/* Form pane */}
                <section className="flex-1 flex flex-col bg-white px-5 py-10 sm:px-8 lg:px-16 lg:py-16">
                    <div className="mb-10 sm:mb-12 flex justify-center lg:justify-start">
                        <img
                            src={process.env.PUBLIC_URL + '/images/logos/dark_transparent.png'}
                            alt="LoanGateway"
                            className="h-8 sm:h-9 w-auto"
                        />
                    </div>

                    <div className="flex-1 flex flex-col justify-center items-center lg:items-start">
                        <form
                            onSubmit={(e) => { this.handleSubmit(e); }}
                            id="kt_login_signin_form"
                            noValidate
                            className="w-full max-w-md"
                        >
                            {this.renderEmailVerificationBanner()}

                            {this.state.showMfaInput
                                ? this.renderMfaForm()
                                : this.renderSignInForm()}

                            <div className="fv-plugins-message-container">
                                <div
                                    data-field="username"
                                    data-validator="notEmpty"
                                    className="fv-help-block"
                                >
                                    {this.renderErrorMessage()}
                                </div>
                            </div>

                            {this.renderAwaitingVerificationCta()}

                            <p className="mt-6 text-center lg:text-left text-sm text-[#6B7280]">
                                Not an admin?{' '}
                                <a
                                    href="/client"
                                    className="font-semibold"
                                    style={{ color: '#5B3FE0' }}
                                >
                                    Client sign in →
                                </a>
                            </p>
                        </form>
                    </div>

                    <p className="mt-10 text-center lg:text-left text-xs text-[#6B7280]">
                        Trouble signing in? Call us on{' '}
                        <a
                            href="tel:0292310511"
                            className="font-semibold"
                            style={{ color: '#5B3FE0' }}
                        >
                            02 9231 0511
                        </a>
                        .
                    </p>
                </section>

                {/* Brand feature pane */}
                <section
                    className="hidden lg:flex flex-col justify-center px-12 py-16 w-1/2 max-w-2xl"
                    style={{ backgroundColor: '#1A1D2A' }}
                >
                    <p
                        className="text-xs font-semibold tracking-widest uppercase mb-4"
                        style={{ color: '#C4B5FD' }}
                    >
                        LoanGateway · Admin
                    </p>
                    <h2 className="text-3xl xl:text-4xl font-bold text-white leading-tight">
                        Run your broker workflow from one secure console.
                    </h2>
                    <p className="mt-5 text-base text-[#C7CAD6] max-w-md leading-relaxed">
                        Manage Fact Finds, Verification of Identity and Document
                        Collection across every application — built by brokers, for
                        brokers.
                    </p>

                    <ul className="mt-10 space-y-3 text-sm text-[#C7CAD6]">
                        <li className="flex items-start gap-3">
                            <span
                                className="inline-flex items-center justify-center h-5 w-5 rounded-full flex-shrink-0 mt-0.5"
                                style={{ backgroundColor: '#7C5CFC', color: '#FFFFFF' }}
                            >
                                <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fillRule="evenodd"
                                        d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </span>
                            Multi-factor authentication for every admin sign in.
                        </li>
                        <li className="flex items-start gap-3">
                            <span
                                className="inline-flex items-center justify-center h-5 w-5 rounded-full flex-shrink-0 mt-0.5"
                                style={{ backgroundColor: '#7C5CFC', color: '#FFFFFF' }}
                            >
                                <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fillRule="evenodd"
                                        d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </span>
                            Real-time tracking across applications and clients.
                        </li>
                        <li className="flex items-start gap-3">
                            <span
                                className="inline-flex items-center justify-center h-5 w-5 rounded-full flex-shrink-0 mt-0.5"
                                style={{ backgroundColor: '#7C5CFC', color: '#FFFFFF' }}
                            >
                                <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fillRule="evenodd"
                                        d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </span>
                            Broker-grade encryption end-to-end.
                        </li>
                    </ul>
                </section>

                {/* Invisible reCAPTCHA container for MFA - required by handleSubmit */}
                <div id="recaptcha-container"></div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
